var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPinterestLogo = function SvgIconPinterestLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.107 4.294A6.5 6.5 0 0 1 18.5 10.5c0 3.628-2.589 5.749-5 5.749-1.259 0-2.01-.408-2.439-.76a2.6 2.6 0 0 1-.393-.4l1.555-6.611a1 1 0 0 0-1.946-.458l-3 12.75a1 1 0 0 0 1.946.458l.925-3.928c.768.523 1.86.949 3.352.949 3.589 0 7-3.091 7-7.75v-.002a8.5 8.5 0 1 0-15.566 4.74 1 1 0 1 0 1.663-1.113 6.5 6.5 0 0 1 3.51-9.831"
  })));
};
export default SvgIconPinterestLogo;